import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { RootState } from "app/store";

// The picture viewer state is global on purpose. The trigger icon renders inside
// MUI Autocomplete options and virtualized DataGrid cells — both unmount their
// subtree while the dialog is open (the autocomplete popper closes as soon as the
// dialog takes focus), which would tear down a locally-mounted dialog immediately.
interface ProductPictureState {
  open: boolean;
  productId: number | null;
}

const initialState: ProductPictureState = {
  open: false,
  productId: null
};

export const productPictureSlice = createSlice({
  name: "productPicture",
  initialState,
  reducers: {
    openProductPicture: (state, action: PayloadAction<number>) => {
      state.open = true;
      state.productId = action.payload;
    },
    closeProductPicture: (state) => {
      state.open = false;
      // productId is intentionally retained so the dialog keeps rendering its
      // image through the MUI close transition.
    }
  }
});

export const { openProductPicture, closeProductPicture } =
  productPictureSlice.actions;

export const selectProductPicture = (state: RootState) => state.productPicture;

export default productPictureSlice.reducer;
